import sdk from '@invivodf/module-stock-sdk'
import type { RealtimeStocksInfo } from './data-transfer-objects'
import type { PartnerId, VariantId } from './domain'

export async function fetchRealtimeStocksByVariants(
  partnerId: PartnerId,
  variantIds: VariantId[],
  options: Parameters<typeof sdk>,
): Promise<Record<VariantId, RealtimeStocksInfo>> {
  const stocksSdk = sdk(...options)
  return stocksSdk.getRealtimeStocks(partnerId, variantIds)
}
